export default (prefix: string, parentHandle?: string) => {
  if (parentHandle === undefined || parentHandle === null) {
    parentHandle = ''
  } else {
    parentHandle = `${parentHandle}/`
  }

  switch (prefix) {
    case 'collection':
      return `data/collections/${parentHandle}`
    case 'page':
      return `data/pages/${parentHandle}`
    case 'product':
      return `data/products/${parentHandle}`
    case 'shop':
      return `data/shop/${parentHandle}`
    case 'article':
      return `data/articles/${parentHandle}`
    case 'blog':
      return `data/blogs/${parentHandle}`
    default:
      return `data/content/${parentHandle}`
  }
}
